import {Button, Loading} from '@ds/components';
import {FullScreenLayout} from '@ds/layout';
import Logo from 'assets/icons/splash/logo.svg';
import PersianExpressLogo from 'assets/icons/splash/persian-snapp-express-logo.svg';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from 'store';
import {getBranches} from 'store/slices/dashboard/thunk';

const Splash: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {loadingBranches, getBranchesError, getBranchesSuccess} = useAppSelector(
    (state) => state.dashboard
  );
  const [errorMessage, setErrorMessage] = useState<React.ReactNode>('');
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleOnlineStatus = () => {
      setIsOnline(navigator.onLine);
      setLoading(true);
    };

    window.addEventListener('online', handleOnlineStatus);
    window.addEventListener('offline', handleOnlineStatus);

    return () => {
      window.removeEventListener('online', handleOnlineStatus);
      window.removeEventListener('offline', handleOnlineStatus);
    };
  }, []);

  useEffect(() => {
    if (!loadingBranches && !getBranchesError && getBranchesSuccess) {
      navigate('/home', {replace: true});
      return;
    }

    if (!loadingBranches && getBranchesError) {
      setLoading(false);
      setErrorMessage(getBranchesError);
    }
  }, [getBranchesError, getBranchesSuccess, loadingBranches, navigate]);

  useEffect(() => {
    if (!isOnline) {
      setLoading(false);
      setErrorMessage(
        <>
          شما به اینترنت وصل نیستید
          <br />
          لطفاً وضعیت اینترنت خود را بررسی کنید
        </>
      );
      return;
    }

    setErrorMessage('');
    const token = localStorage.getItem('access_token');

    if (!token) {
      navigate('/login', {replace: true});
      return;
    }

    void dispatch(getBranches({page: 0, pageSize: 10}))
      .unwrap()
      .then((response) => {
        localStorage.setItem('isVendor', String(Boolean(response?.branches?.length)));
      });
  }, [dispatch, isOnline, navigate]);

  return (
    <FullScreenLayout className="relative bg-orange-splash!">
      <div className="flex flex-col items-center justify-center gap-3.5 pt-[30%]">
        <img src={Logo} alt="لوگوی اسنپ اکسپرس" />
        <span className="text-body-md-emphasis text-white">همراه فروش شما</span>
      </div>

      <div className="absolute bottom-11 flex w-full flex-col items-center justify-center gap-11.5">
        {errorMessage && (
          <div className="flex flex-col items-center gap-4.5">
            <span className="flex flex-col items-center justify-center text-center text-body-sm-emphasis text-white">
              {errorMessage}
            </span>
            <Button
              size="lg"
              variant="fill"
              color="secondary"
              onClick={() => window.location.reload()}
            >
              تلاش مجدد
            </Button>
          </div>
        )}

        <div className="flex flex-col items-center justify-center gap-3">
          <img src={PersianExpressLogo} alt="لوگوی فارسی اسنپ اکسپرس" />
          {loading && (
            <div className="flex w-7">
              <Loading size="small" color="inverse" />
            </div>
          )}
        </div>
      </div>
    </FullScreenLayout>
  );
};

export default Splash;
